
;(function seibertronHpilgGalleryRestore20260713() {
  var handle = 'seibertron-h-p-i-l-g-touchscreen-football-receiver-gloves-flexible-breathable-impact-protection-back-of-hand-glove-adult-and-youth-sizes';
  var chartFile = 'football-hpilg-adult-size-chart-user-vertical-20260722-v1.jpg';
  var entries = [
    {
        "id": "33403885027518",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/02_7a3b43e8-fd96-4352-87f9-19e5c5212655.jpg?v=1783676167",
        "alt": "color:Black | Seibertron H.P.I.L.G football lineman gloves white background main image"
    },
    {
        "id": "33373096902846",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-hpilg-gallery-01.jpg?v=1783389212",
        "alt": "color:Black | Seibertron H.P.I.L.G touchscreen football lineman gloves image 01"
    },
    {
        "id": "33373096935614",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-hpilg-gallery-02.jpg?v=1783389212",
        "alt": "color:Black | Seibertron H.P.I.L.G touchscreen football lineman gloves image 02"
    },
    {
        "id": "33373096968382",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-hpilg-gallery-03.jpg?v=1783389212",
        "alt": "color:Black | Seibertron H.P.I.L.G touchscreen football lineman gloves image 03"
    },
    {
        "id": "33431808344254",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hpilg-football-lineman-gloves-white-white-bg-20260713.jpg?v=1783927864",
        "alt": "color:White | Seibertron H.P.I.L.G football lineman gloves white background main image"
    },
    {
        "id": "33373097001150",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-hpilg-gallery-04.jpg?v=1783389212",
        "alt": "color:White | Seibertron H.P.I.L.G touchscreen football lineman gloves image 04"
    },
    {
        "id": "33373097033918",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-hpilg-gallery-05.jpg?v=1783389212",
        "alt": "color:White | Seibertron H.P.I.L.G touchscreen football lineman gloves image 05"
    },
    {
        "id": "33373097066686",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-hpilg-gallery-06.jpg?v=1783389212",
        "alt": "color:White | Seibertron H.P.I.L.G touchscreen football lineman gloves image 06"
    },
    {
        "id": "33373097099454",
        "src": "//cdn.shopify.com/s/files/1/0623/6153/4654/files/football-hpilg-gallery-07.jpg?v=1783389212",
        "alt": "color:all | Seibertron H.P.I.L.G touchscreen football lineman gloves image 07"
    }
];
  var groups = {
    "Black": [
        "33403885027518",
        "33373096902846",
        "33373096935614",
        "33373096968382",
        "33373097099454"
    ],
    "White": [
        "33431808344254",
        "33373097001150",
        "33373097033918",
        "33373097066686",
        "33373097099454"
    ]
};
  var entryById = {};
  entries.forEach(function (entry) { entryById[entry.id] = entry; });

  function section() { return document.querySelector('.auto-product[data-product-handle="' + handle + '"]'); }
  function absolute(url) { if (!url) return ''; if (url.indexOf('//') === 0) return window.location.protocol + url; if (url.charAt(0) === '/') return window.location.origin + url; return url; }
  function sized(url, width) { try { var parsed = new URL(absolute(url), window.location.origin); parsed.searchParams.set('width', String(width)); return parsed.href; } catch (error) { return absolute(url); } }
  function escapeHtml(value) { return String(value || '').replace(/[&<>"']/g, function (character) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]; }); }
  function scriptUrl(file) {
    var own = Array.prototype.find.call(document.scripts, function (script) { return script.src && script.src.indexOf('hpilg-gallery-restore-20260713.js') !== -1; });
    if (own) return own.src.replace('hpilg-gallery-restore-20260713.js', file);
    return '/cdn/shop/t/16/assets/' + file;
  }
  function selectedValue(root) {
    var checked = root.querySelector('input[name="options[Color]"]:checked, input[name="options[color]"]:checked');
    return checked ? checked.value : 'Black';
  }
  function groupFor(value) {
    return (groups[value] || groups.Black || []).map(function (id) { return entryById[id]; }).filter(Boolean);
  }
  function setMain(root, entry) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function setActiveThumb(root, activeId) {
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === activeId);
    });
  }
  function ensureThumb(root, wrap, entry, index, visibleIds) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
    }
    wrap.appendChild(thumb);
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.hidden = false;
    thumb.setAttribute('aria-hidden', 'false');
    thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    thumb.onclick = function () {
      setMain(root, entry);
      setActiveThumb(root, entry.id);
    };
    visibleIds[entry.id] = true;
  }
  function showGroup(root, value, preferredId) {
    var wrap = root.querySelector('.auto-product__thumbs');
    var group = groupFor(value);
    if (!group.length) return;
    var visibleIds = {};
    if (wrap) {
      group.forEach(function (entry, index) { ensureThumb(root, wrap, entry, index, visibleIds); });
      root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
        var show = !!visibleIds[thumb.getAttribute('data-media-id')];
        thumb.hidden = !show;
        thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }
    var active = entryById[preferredId] && visibleIds[preferredId] ? entryById[preferredId] : group[0];
    setMain(root, active);
    setActiveThumb(root, active.id);
  }
  function hydrateSwatches(root) {
    root.querySelectorAll('[data-auto-visual-option-value]').forEach(function (label) {
      var value = label.getAttribute('data-auto-visual-option-value') || '';
      var entry = groupFor(value)[0];
      var shell = label.querySelector('[data-auto-choice-label]');
      if (!entry || !shell) return;
      shell.dataset.display = value;
      shell.innerHTML = '<span class="auto-product__swatch-image" aria-label="' + escapeHtml(value) + '"><img src="' + escapeHtml(sized(entry.src, 180)) + '" alt="' + escapeHtml(value) + '" width="72" height="72" loading="lazy"></span><span class="auto-product__swatch-label">' + escapeHtml(value) + '</span>';
    });
  }
  function replaceChart(root) {
    var url = scriptUrl(chartFile);
    var selector = 'img.auto-product__guide-image, img[src*="football-hpilg-unisex-size-chart"]';
    root.querySelectorAll(selector).forEach(function (img) {
      img.src = url;
      img.srcset = '';
      img.width = 1600;
      img.height = 2200;
      img.alt = 'Seibertron H.P.I.L.G football lineman gloves unisex size chart';
    });
  }
  function run() {
    var root = section();
    if (!root) return;
    replaceChart(root);
    hydrateSwatches(root);
    showGroup(root, selectedValue(root));
    if (!root.dataset.hpilgGalleryRestoreBound) {
      root.dataset.hpilgGalleryRestoreBound = 'true';
      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[name^="options["]')) {
          window.setTimeout(function () { hydrateSwatches(root); showGroup(root, selectedValue(root)); replaceChart(root); }, 0);
          window.setTimeout(function () { hydrateSwatches(root); showGroup(root, selectedValue(root)); replaceChart(root); }, 500);
          window.setTimeout(function () { hydrateSwatches(root); showGroup(root, selectedValue(root)); replaceChart(root); }, 1200);
        }
      });
    }
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  window.setTimeout(run, 250);
  window.setTimeout(run, 1000);
  window.setTimeout(run, 2500);
  window.setTimeout(run, 5000);
})();
